import styled from "styled-components";

export const ActionHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  font-size: 1.125rem;
  text-align: left;
  @media (max-width: 768px) {
    height: 100%;
    font-size: 1rem;
  }
`;

export const Title = styled.div`
  padding: 0 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 100%;
  @media (max-width: 767px) {
    padding: 0 0.5rem;
    padding-top: 0.22rem;
  }
`;
